import {
  useEffect,
  useRef,
  type CSSProperties,
  type HTMLAttributes,
  type ReactNode,
} from "react";
import { cn } from "../cn";

export type PropsRkReveal = HTMLAttributes<HTMLDivElement> & {
  readonly delayMs?: number;
  readonly children: ReactNode;
};

/**
 * Scroll reveal — IntersectionObserver uma unica vez.
 */
export function Reveal({
  delayMs = 0,
  className,
  children,
  style,
  ...resto
}: PropsRkReveal) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entrada]) => {
        if (entrada?.isIntersecting) {
          el.classList.add("is-visible");
          obs.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px" },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      {...resto}
      ref={ref}
      className={cn("rk-reveal", className)}
      style={
        {
          ...style,
          ["--rk-reveal-delay" as string]: `${delayMs}ms`,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
